<template>
  <v-container fluid>

  <div class="headline text-xs-left">
    Seller Setup
  </div>

  <LearnItem>
    <template slot="title">How do I change my name? </template>
    Your name is set on the <router-link :to="{name: 'SellerSettings'}">Seller Settings</router-link> page.
    <br /><br />
    Your name is used in emails to buyers and as the name of your store.
    <br /><br />
    Always use your first name and never your last name.
   </LearnItem>
   <LearnItem>
     <template slot="title">How to add information about me?</template>
     Adding a personal biography helps buyers know you a little and want to buy from
     you. You should write about why you're selling on SmartKidsMarket. If you make
     the items you sell, describe how you got into making them and why you love it. You can also
     talk about hobbies or other interests, charities you may donate some of your profits to.
     <br />
     <br />
     Because this information is public you should never add your last name, phone number,
     or where you live.
     <br />
     <br />
     The biography will show up on your store page immediately.
     Always check with your mom or dad before posting!
  </LearnItem>

  <LearnItem>
    <template slot="title">Adding a profile picture</template>
    You can add a picture of yourself from the <router-link :to="{name: 'SellerSettings'}">Seller Settings</router-link> page.

    <br />The picture will show up on your store immediately.
    Always check with your mom or dad before posting a picture!
  </LearnItem>

  </v-container>

</template>

<script>

import LearnItem from './LearnItem.vue'

export default {
  components: {
    LearnItem
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

</style>
